import { Injectable } from '@angular/core';
import { FormInstance } from '@models/global-forms';
import { MatterWordDocument } from '@models/matter-word-documents';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './matter-packages.actions';
import {
	MatterPackageContentType,
	MatterPackageContentDocumentType,
	MatterPackageCustomizations,
	MatterPackageContent,
} from '@models/matter-package';
import { MatterWordDocumentWithMetadata } from '../matter-word-documents/matter-word-documents.selectors';

@Injectable({
	providedIn: 'root',
})
export class MatterPackagesDispatch {
	@Dispatch()
	SelectPackage = (payload) => {
		return new actions.SelectPackage(payload);
	};

	@Dispatch()
	Create = (payload: {
		id?: string;
		packageName: string;
		documents?: (MatterWordDocumentWithMetadata & {
			contentType: MatterPackageContentType;
		})[];
		packageTemplateId?: string;
		packageHash?: string;
	}) => {
		return new actions.Create(payload);
	};

	@Dispatch()
	UpdatePackageName = (payload) => {
		return new actions.UpdatePackageName(payload);
	};

	@Dispatch()
	AddContent = (payload: {
		docMetadata: {
			id: string;
			title: string;
			type: MatterPackageContentType;
			contentType: MatterPackageContentDocumentType;
			content: MatterWordDocument | FormInstance;
		};
		duplicated?: boolean;
		generated?: boolean;
	}) => {
		return new actions.AddContent(
			payload.docMetadata,
			payload.duplicated,
			payload.generated,
		);
	};

	@Dispatch()
	RemoveContent = (payload: { packageId: string; contentId: string }) => {
		return new actions.RemoveContent(payload);
	};

	@Dispatch()
	ReorderContent = (payload: {
		id: string;
		contentId: string;
		newIndex: number;
	}) => {
		return new actions.ReorderContent(payload);
	};

	@Dispatch()
	DeletePackage = (id: string) => {
		return new actions.DeletePackage({ id });
	};

	@Dispatch()
	TrackCustomization = (payload: {
		packageId: string;
		action: 'add' | 'remove';
		documentId: string;
	}) => {
		return new actions.TrackCustomization(payload);
	};

	@Dispatch()
	SyncPackageContents = (payload: {
		packageId: string;
		contents: MatterPackageContent[];
		documents: MatterWordDocumentWithMetadata[];
		customizations: MatterPackageCustomizations;
	}) => {
		return new actions.SyncPackageContents(payload);
	};

	@Dispatch()
	SyncPackageWithVirtual = (payload: {
		matterPackageId: string;
		virtualPackageHash?: string;
		virtualContents?: MatterPackageContent[];
		virtualDocuments?: (MatterWordDocumentWithMetadata & { id: string })[];
	}) => {
		return new actions.SyncPackageWithVirtual(payload);
	};
}
